var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCryplon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 43,
    viewBox: "0 0 46 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3431 34.9147C45.3431 22.6468 35.2413 12.7081 22.7835 12.7081C10.3258 12.7081 0.21875 22.6468 0.21875 34.9147H0.254994C0.239461 35.032 0.21875 35.1492 0.21875 35.2664V39.2725C0.21875 41.0716 1.71513 42.5446 3.54288 42.5446H42.019C43.8467 42.5446 45.3431 41.0716 45.3431 39.2725V35.2664C45.3431 35.1441 45.3224 35.032 45.3069 34.9147H45.3431Z",
    fill: "#FFD200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7683 0.455383H2.73887C1.33195 0.455383 0.191406 1.57808 0.191406 2.963V7.33603C0.191406 8.72095 1.33195 9.84365 2.73887 9.84365H42.7683C44.1752 9.84365 45.3158 8.72095 45.3158 7.33603V2.963C45.3158 1.57808 44.1752 0.455383 42.7683 0.455383Z",
    fill: "#4BBA36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCryplon);
export default __webpack_public_path__ + "static/media/logo-cryplon.59b055168576143d2376808d749ba26e.svg";
export { ForwardRef as ReactComponent };